<template>
    <transition name="slide-fade">
        <div class="pop-box pop-booth">
            <router-link
                to="/"
                class="btn-back"
            ><i class="remixicon-arrow-left-s-line"></i>返回</router-link>
            <div class="cnt">
                <div class="subtitle">{{ (id/Math.pow(10, 2)).toFixed(2).substr(2) }}</div>
                <div class="title">{{ title }}</div>
                <div class="box-category">
                    <router-link
                        :to="`/product/${ category }/${ item.id }`"
                        class="category"
                        v-for="(item, index) in categories"
                        :key="index"
                    >
                        <img
                            :src="require(`@/assets/images/${ item.cover }`)"
                            alt=""
                        />
                        <p class="name">{{ item.name }}</p>
                    </router-link>
                </div>
            </div>
            <!-- <div class="btn-more"><i class="remixicon-add-line"></i>更多详情</div> -->
        </div>
    </transition>
</template>

<script>
import data from "@/data/cate.js";
import Bus from '@/eventbus.js'

export default {
    name: "PopCate",
    data() {
        return {
            id: 0,
            title: '',
            category: '',
            categories: []
        };
    },
    created() {
        this.initData()
    },
    methods: {
        initData() {
            const { productCate } = this.$route.params
            const cateData = data.find(
                (item, index) => item.category == productCate
            )
            
            if (cateData) {
                const { id, title, categories } = cateData
                this.id = id
                this.title = title
                this.category = productCate
                this.categories = categories
            }
        }
    },
    activated() {
        console.log('active cate...')
        setTimeout(() => Bus.$emit('switchCate', true), 100)
    },
    watch: {
        $route(to, from) {
            this.initData()
            if (to.path === '/') {
                setTimeout(() => Bus.$emit('switchCate', false), 100)
            }
        }
    }
};
</script>

<style lang="scss">

</style>